import { Checkbox as HeroCheckbox } from "@heroui/react";
import { getButtonVariantColors } from "../../theme/colors";

interface CustomCheckboxProps {
  name?: string;
  size?: "sm" | "md" | "lg";
  isSelected?: boolean;
  onValueChange?: (checked: boolean) => void;
  children?: React.ReactNode;
  className?: string;
  disabled?: boolean;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  name,
  size = "sm",
  isSelected = false,
  onValueChange,
  children,
  className = "",
  disabled = false,
}) => {
  const variantColors = getButtonVariantColors('primary');
  const isPartner = window.location.pathname.startsWith('/partner');
  
  return (
    <HeroCheckbox
      name={name}
      size={size}
      isSelected={isSelected}
      onValueChange={onValueChange}
      disabled={disabled}
      className={`${isPartner ? 'partner-checkbox' : 'client-checkbox'} ${className}`}
      color="primary"
      classNames={{
        wrapper: "after:bg-blue-500",
        icon: "text-white",
        base:'h-[24px]'
      }}
      style={{
        // '--nextui-primary': variantColors.background,
        // '--nextui-primary-foreground': variantColors.text,
        // backgroundColor: isSelected ? variantColors.background : 'transparent',
        // borderColor: isSelected ? variantColors.background : '#d1d5db',
      } as React.CSSProperties}
    >
      {children}
    </HeroCheckbox>
  );
};

export default CustomCheckbox;
